define('constants/marketingContactFormTypeEnumerations',[], function() {
    return {
        contactUs : "Contact Us",
        demoRequest : "Demo Request"
    };
});
